import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {Auth} from 'aws-amplify';
import packageJson from '../package.json';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import {Link, useHistory, useLocation} from 'react-router-dom';
import {LinkContainer} from 'react-router-bootstrap';
import ErrorBoundary from './components/ErrorBoundary';
import {AppContext} from './libs/contextLib';
import RoutesComponent from './RoutesComponent';
import './App.css';
import config from './config';
import ExportModal from './components/Export';
import {getOperator, getPubOperator, setUserOperator, startFreeTrial} from './services/routeService';
import logoImage from './assets/images/busable-logo-1.svg';
import logoImage2 from './assets/images/busable-logo-2.svg';
import {ReactComponent as Import} from './assets/icons/Import.svg';
import {
    driverModelData,
    driverShiftModelData,
    operatorModelData,
    publicScheduleModelData,
    routeModelData,
    routesModelExpiryService,
    scheduleModelData,
    stopModelData,
    vehicleModelData
} from './services/ModelService';
import {GetFullUrl, getKey} from './libs/hooksLib';
import {Button, Image} from 'react-bootstrap';
import CookieConsent from 'react-cookie-consent';
import util from 'util';
import {MenuOutlined, PlusOutlined} from '@ant-design/icons';
import {Alert, Breadcrumb, Flex, Layout, Menu, message, notification, Typography, Tooltip} from 'antd';
import {ReactComponent as Marketplace} from './assets/icons/Marketplace.svg';
import {ReactComponent as Globe} from './assets/icons/Globe.svg';
import {ReactComponent as Explore} from './assets/icons/Explore.svg';
import {ReactComponent as SMS} from './assets/icons/SMS.svg';
import {ReactComponent as Services} from './assets/icons/Services.svg';
import {ReactComponent as Pin} from './assets/icons/Pin.svg';
import {ReactComponent as Calendar} from './assets/icons/Calendar.svg';
import {ReactComponent as Transfers, ReactComponent as Trackable} from './assets/icons/Transfers.svg';
import {ReactComponent as Rostering} from './assets/icons/Rostering.svg';
import {ReactComponent as HR} from './assets/icons/HR.svg';
import {ReactComponent as OTR} from './assets/icons/OTR.svg';
import imgCharterable, {ReactComponent as BusSM} from './assets/icons/Bus_sm.svg';
import {ReactComponent as Timetable} from './assets/icons/Timetable.svg';
import {ReactComponent as Export} from './assets/icons/Export.svg';
import {ReactComponent as Settings} from './assets/icons/Settings.svg';
import {ReactComponent as Info} from './assets/icons/Info.svg';
import {ReactComponent as Help} from './assets/icons/Help.svg';
import {ReactComponent as Logout} from './assets/icons/Logout.svg';
import {ReactComponent as Switch} from './assets/icons/Switch.svg';
import {ReactComponent as User} from './assets/icons/user.svg';
import imgPlanable from './assets/icons/Planable.png';
import imgRosterable from './assets/icons/Rosterable.png';
import imgReportable from './assets/icons/Reporting.svg';
import imgPublishable from './assets/icons/Publishable.png';
import imgTrackable from './assets/icons/Mapable.png';
import Hotjar from '@hotjar/browser';
import ReactGA from 'react-ga4';
import FaultModal from './components/FaultModal';
import store from 'store2';
import Features from './model/features';
import {values} from 'lodash/object';
import AdminModal from './components/Admin';
import {ReactComponent as ResetIcon} from './assets/icons/ResetCache.svg';
import {getEditor} from './hooks/getEditor';
import {checkOnline} from './libs/errorLib';
import dayjs from './dayjs';
import useEditor from './hooks/useEditor';
import useAllComments from './hooks/useAllComments';
import {ChatContext} from './model/Comment';
import GtfsImportModal from './features/Import/GtfsImportModal';
import { BookingProvider } from "./features/Bookings/BookingContext";
import ReportIssueButton from './components/ReportIssueButton';
import {BarChartOutlined} from '@ant-design/icons';
import {ReportsProvider} from './features/Reportable/ReportsContext';
import MessageCard from './components/MessageCard';
import useViewBlocking from './hooks/useViewBlocking';
import VersionInfo from './components/VersionInfo';
import SplashPage from './components/SplashPage';
import VersionCheckPage from './components/VersionCheckPage';
import Intercom, {shutdown} from '@intercom/messenger-js-sdk';


const {Header, Content, Sider} = Layout;

const PUBLIC_PATHS = [
    '/timetable',
    '/trip_planner',
    '/school_list',
    '/venue_list',
    '/p_sb',
    '/confirm-booking',
    '/trial',
    '/bookings',
    '/login',
    '/reset',
    '/logout',
    '/whats-new',
    '/first-time-login-help'
];



export const checkAuth = async (setFaultState) => {
    try {
        if (process.env.REACT_APP_STAGE !== 'local') {
            if (!await checkOnline()) {
                return setFaultState(state => state.type === 'offline' ? state : {type: 'offline'});
            }

            const user = await Auth.currentUserInfo();
            if (user?.attributes) {
                // if (user.attributes["custom:operatorId"] !== operatorId) {
                //     console.log('Region has changed from %s to %s', operatorId, user.attributes["custom:operatorId"])
                //     // region changed in session
                //     setFaultState({type: 'refresh'})
                // }
                return setFaultState(state => state.type === 'none' ? state : {type: 'none'});
            } else {
                console.log('User has been logged out. User: ', user);
                // Not logged in, show logged out modal.
                return setFaultState(state => state.type === 'loggedOut' ? state : {type: 'loggedOut'});
            }
        }

    } catch (e) {
        console.log('Fault check error: ', e);
        return setFaultState(state => state.type === 'offline' ? state : {type: 'offline'});
    }
};

export const checkFeatureAuth = async (setFaultState, operator, feature, onCancel) => {

    await checkAuth(setFaultState);
    try {
        const user = await Auth.currentUserInfo();
        if (user?.attributes?.['custom:isAdmin'] === 'true') {
            return true;
        }
        // if logged in, then check feature access
        if (!operator?.features || !operator.features.access(feature)) {
            if (feature.trial && !operator.features.isInTrialPeriod(feature.key)) {
                // Offer trial period modal
                setFaultState({
                    type: 'trial', feature, operator, onClick: async () => {
                        operator.features = new Features(await startFreeTrial(operator, feature.key));
                    }, onCancel
                });
            } else {
                // no access and trial over show subscription modal.
                setFaultState({type: 'subscription', feature, onClick: onCancel, onCancel});
            }
            return false;
        }
        // if access granted, then proceed
        return true;
    } catch (e) {
        console.log('Action error: ', e);
        return false;
    }
};

function getItem(label, key, icon, className, children) {
    return {
        key,
        icon,
        children,
        label,
        className
    };
}

function getFeatureFlaggedItem(operator, label, key, icon, className, children) {
    if (!operator) return;

    if (operator.features.all || operator.features.beta || operator.features[key.toLowerCase()])
        return {
            key,
            icon,
            children,
            label,
            className
        };
}

const CustomToggle = React.forwardRef(({children, onClick}, ref) => (
    <Button variant={'link'} className="region-toggle" ref={ref} onClick={(e) => {
        e.preventDefault();
        onClick(e);
    }}>
        {children}
    </Button>
));
const CustomMenu = React.forwardRef(
    ({children, style, className, 'aria-labelledby': labeledBy, isAdmin, hideBackupRegions, setHideBackupRegions}, ref) => {
        // eslint-disable-next-line
        const [value, setValue] = useState('');
        return (
            <div
                ref={ref}
                style={style}
                className={className}
                aria-labelledby={labeledBy}
            >
                <div className="d-flex align-items-center px-3">
                    <Form.Control
                        autoFocus
                        placeholder="Find Region..."
                        onChange={(e) => setValue(e.target.value.toLowerCase())}
                        value={value}
                    />
                    <Tooltip title="Hide Backup Regions">
                        <Button 
                            variant={hideBackupRegions ? "primary" : "outline-primary"}
                            className="filter-backup icon-button btn-border" 
                            title="Hide Backup Regions"
                            onClick={() => setHideBackupRegions(!hideBackupRegions)}
                        >
                            {hideBackupRegions ? "✓" : "✗"}
                        </Button>
                    </Tooltip>
                    {isAdmin && 
                        <Tooltip title="Add New Region">
                            <Button href="/new_operator" className="new-region icon-button btn-border" title="New Region"><PlusOutlined size={18}/></Button>
                        </Tooltip>
                    }
                </div>
                <ul className="list-unstyled">
                    {React.Children.toArray(children).filter(
                        (child) =>
                            !value || child.props.children.toString().toLowerCase().includes(value),
                    )}
                </ul>
            </div>
        );
    },
);

const getSubMenu = (pathname, operator, isAdmin) => {
    if (!pathname?.length || !pathname.split('/').length) {
        return 'Planable';
    }

    // for optibus operators, show charterable only
    if (!isAdmin && operator?.opts?.external?.optibus?.apiKey){
      return "Charterable"
    }

    switch (pathname.split('/')[1]) {
        case 'services':
        case 'points':
        case 'calendars':
        case 'calendars-v2':
        case 'transfers':
            return 'Planable';
        case 'charters':
        case 'bookings':
        case 'enquiries':
        case 'customers':
            return 'Charterable';
        case 'shiftbats':
        case 'rostering':
        case 'blocks':
        case 'deadruns':
            return 'Rosterable';
        case 'trip_planner':
        case 'timetables':
        case 'school_list':
        case 'venue_list':
            return 'Publishable';
        case 'hrm':
        case 'policies':
        case 'vehicleTypes':
        case 'fleet':
        case 'students':
            return 'Manageable';
        case 'marketplace':
        case 'sms':
            return 'Apps';
        case 'settings':
            return 'Settings';
        case 'fleet_monitoring':
            return 'Trackable';
        case 'admin':
        case 'otr':
        case 'osr':
        case 'visualizer':
        case 'diff':
        case 'otr-dashboard':
        case 'reportable':
            return 'Reportable'
        default:
            return null;
    }
};

const getMenu = (pathname) => {
    if (!pathname?.length) {
        return 'Services';
    }
    
    // Handle executive dashboard specifically
    if (pathname === '/bookings/executive-dashboard') {
        return 'Dashboard';
    }
    
    switch (pathname.split('/')[1]) {
        case 'services':
            return 'Services';
        case 'points':
            return 'Points';
        case 'calendars':
            return 'Calendars';
        case 'calendars-v2':
            return 'Calendars v2';
        case 'transfers':
            return 'Transfers';
        case 'charters':
            return 'Charters';
        case 'bookings':
            return 'Bookings';
        case 'enquiries':
            return 'Enquiries';
        case 'customers':
            return 'Customers';
        case 'shiftbats':
            return 'Driver Duties';
        case 'trip_planner':
            return 'Journey Planner';
        case 'timetables':
            return 'Service Timetables';
        case 'school_list':
            return 'School Timetables';
        case 'venue_list':
            return 'Venue Timetables';
        case 'hrm':
            return 'Staff';
        case 'policies':
            return 'Policy';
        case 'fleet':
            return 'Fleet';
        case 'vehicleTypes':
            return 'Vehicle Types';
        case 'deadruns':
            return 'Deadruns';
        case 'students':
            return 'Students';
        case 'marketplace':
            return 'Marketplace';
        case 'sms':
            return 'SMS';
        case 'rostering':
            return 'Rosters';
        case 'settings':
            return 'Settings';
        case 'jobs':
            return 'Jobs';
        case 'fleet_monitoring':
            return 'Real-Time Fleet Tracking';
        case 'fleet_monitoring_v2':
            return 'Fleet Tracking V2';
        case 'admin':
            return 'Admin';
        case 'reportable':
            // Handle reportable sub-routes
            if (pathname.includes('/reportable/admin')) {
                return 'Admin';
            } else if (pathname.includes('/reportable/otr-dashboard')) {
                return 'On Time Running Dashboard';
            } else if (pathname.includes('/reportable/osr')) {
                return 'Operational Reports';
            } else if (pathname.includes('/reportable/visualizer')) {
                return 'Visualizer';
            } else if (pathname.includes('/reportable/diff')) {
                return 'Diff-Checker';
            }
            return 'Reportable';
        case 'otr':
            return 'On Time Running';
        case 'osr':
            return 'Operational Reports';
        case 'visualizer':
            return 'Visualizer';
        case 'diff':
            return 'Diff-Checker';
        case 'otr-dashboard':
            return 'On Time Running Dashboard';
        case 'blocks':
            return 'Blocks'
        default:
            return 'Services';
    }
};

export const APP_VERSION = packageJson.version;

export default function App(props) {

    const version = APP_VERSION;
    const release_notes = 'https://help.busable.app/col/whats-new';
    const history = useHistory();
    const location = useLocation();
    const fullUrl = GetFullUrl();
    const [isAuthenticating, setIsAuthenticating] = useState(true);
    const [isAuthenticated, userHasAuthenticated] = useState(false);
    const [isModelServiceReady, setIsModelServiceReady] = useState(false);
    const [user, setUser] = useState(null);
    const [email, setEmail] = useState(null);
    const [givenName, setGivenName] = useState(null);
    const [familyName, setFamilyName] = useState(null);
    const [schedules, setSchedules] = useState({});
    const [privateSchedules, setPrivateSchedules] = useState(null);
    const [publicSchedules, setPublicSchedules] = useState(null);
    const [driverShifts, setDriverShifts] = useState(null);
    // const [drivers, setDrivers] = useState({})
    const [vehicles, setVehicles] = useState(null);
    const [apiKey, setApiKey] = useState(null);
    const [operator, setOperator] = useState(null);
    const [allowedOperators, setAllowedOperators] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [features, setFeatures] = useState({});
    //const [noLogo, setNoLogo] = useState(false)

    const [pageTitle, setPageTitle] = useState(getMenu(location.pathname));
    const [breadcrumbs, setBreadcrumbs] = useState([]);
    const [breadcrumb, setBreadcrumb] = useState(null);
    const [items, setItems] = useState(null);

    const [collapsed, setCollapsed] = useState(false);
    const [isExpanding, setIsExpanding] = useState(false);
    const autoCollapsedRouteRef = useRef(null); // Track which route we've auto-collapsed for

    const [faultState, setFaultState] = useState({type: 'none', feature: null});

    const [messageApi, contextHolder] = message.useMessage();

    const [notificationApi, notificationContextHolder] = notification.useNotification();
    const [faultModalVisible, setFaultModalVisible] = useState(false);

    const [versionChoiceMade, setVersionChoiceMade] = useState(false);
    const [jwtToken, setJwtToken] = useState(null);
    const [hideBackupRegions, setHideBackupRegions] = useState(true);

    const [editor, setEditor] = useEditor({user});
    const [chatOpen, setChatOpen] = useState(false);
    const [chatContext, setChatContext] = useState(new ChatContext({type: 'all'}));
    const { isMenuItemBlocked } = useViewBlocking();
    const {allRouteComments, allStopComments} = useAllComments();

    const isPublic = PUBLIC_PATHS.some(publicPath => window.location.pathname.includes(publicPath));

    // Check if both authentication and model service are ready
    const isAppReady = !isAuthenticating && isAuthenticated && isModelServiceReady;
    
    // Debug logging - throttled to prevent excessive logging
    if (!window._lastAppStateLog || Date.now() - window._lastAppStateLog > 1000) {
        console.log('App state:', { isAuthenticating, isAuthenticated, isModelServiceReady, isAppReady });
        window._lastAppStateLog = Date.now();
    }

    useEffect(() => {
        if(user && operator) {
            let createdAt = null;
            if (user.signInUserSession?.idToken?.payload) {
                const payload = user.signInUserSession.idToken.payload;
                createdAt = payload.iat || payload.auth_time;
            }
            if (!createdAt) {
                createdAt = Math.floor(Date.now() / 1000);
            }
            Intercom({
                app_id: 'w0oyc6tj',
                user_id: user.id,
                name: user.attributes.given_name + ' ' + user.attributes.family_name,
                email: user.attributes.email,
                created_at: createdAt,
                operator_id: operator.id,
                operator_name: operator.name,
            });
        }
    }, [user, operator]);

    const handleVersionProceed = useCallback(() => {
        store.set('busable-version', version);
        setVersionChoiceMade(true);
    }, [version]);

    const handleVersionClearCache = useCallback(() => {
        store.set('busable-version', version);
        setVersionChoiceMade(true);
        window.location.replace('/');
    }, [version]);

    const handleLogout = useCallback(() => {
        (async () => {
            console.log('Shutting down Intercom...');
            shutdown();
            await Auth.signOut()

            routeModelData.clear();
            stopModelData.clear();
            scheduleModelData.clear();
            publicScheduleModelData.clear();
            vehicleModelData.clear();
            driverModelData.clear();
            userHasAuthenticated(false);
            setSchedules(null);
            setPrivateSchedules(null);
            setPublicSchedules(null);
            setApiKey(null);
            setEmail(null);
            setUser(null);
            setGivenName(null);
            setFamilyName(null);
            setFeatures(features => {
                features?.revoke && features.revoke();
                return null;
            });
            setOperator(null);
            setAllowedOperators(null);
            setIsAdmin(false);
            setIsModelServiceReady(false);

            try {
                routesModelExpiryService.deinit();
                await routesModelExpiryService.deleteAllDbs();
            } catch(e) {
                console.error('Error removing cache: ', e);
            }
            try {
                store.clearAll();
            } catch(e) {
                console.error('Error removing cache: ', e);
            }

        })().then('Logged out.');
    }, [userHasAuthenticated, setSchedules, setPrivateSchedules, setPublicSchedules, setApiKey, setUser, setEmail, setGivenName, setFamilyName, setFeatures,
        setOperator, setAllowedOperators, setIsAdmin]);

    useEffect(() => {
        const getTokenAndRedirect = async () => {
            try {
                const session = await Auth.currentSession();
                const idToken = session.getIdToken().getJwtToken();
                setJwtToken(idToken);

            } catch (error) {
                console.error('Error getting token:', error);
            }
        };

        // Example: Redirect on some condition or event
        getTokenAndRedirect();
    }, []);

    useEffect(() => {
        document.body.classList.add('busable-app');

        async function handleRefresh() {
            window.location.reload();
        }

        if (!schedules || !operator || !setFaultState || !handleLogout) {
            if (isAdmin) {
                setItems([getItem(<AdminModal allowedOperators={allowedOperators} isAdmin={isAdmin}
                                              apiKey={apiKey} messageApi={messageApi}/>, 'Admin', <Settings/>),
                    getItem(<Nav.Link onClick={handleLogout}>{givenName || 'Logout'}
                        <Logout/></Nav.Link>, 'Logging out...', <div
                        className="user-image"><User/></div>)]);
            }
            return;
        }

        // Check if operator has Optibus integration
        const hasOptibusIntegration = operator?.opts?.external?.optibus?.apiKey;

        if (hasOptibusIntegration && !isAdmin) {
            // Show only Charterable menu and essential items for Optibus-integrated non-admin users
            setItems([
                getItem('Charterable', 'Charterable', <img src={imgCharterable} alt=""/>, '', [
                    // Only show menu items that are not blocked
                    !isMenuItemBlocked('/bookings/executive-dashboard') && getItem(<LinkContainer to="/bookings/executive-dashboard"><Nav.Link>Dashboard</Nav.Link></LinkContainer>, 'Dashboard', <BarChartOutlined />),
                    !isMenuItemBlocked('/bookings') && getItem(<LinkContainer to="/bookings" className="badge-beta"><Nav.Link>Bookings</Nav.Link></LinkContainer>, 'Bookings',<BusSM/>),
                    !isMenuItemBlocked('/customers') && getItem(<LinkContainer to="/customers"
                                           className="badge-beta"><Nav.Link>Customers</Nav.Link></LinkContainer>, 'Customers',
                        <HR/>),
                    !isMenuItemBlocked('/points') && getItem(<LinkContainer to="/points"><Nav.Link>Points</Nav.Link></LinkContainer>, 'Points', <Pin/>),
                ].filter(Boolean)), // Remove falsy values
                !isMenuItemBlocked('/settings') && getItem('Settings', 'Settings', <Settings/>, 'MenuBottom', [
                    getItem(<LinkContainer to="/settings"><Nav.Link>Account</Nav.Link></LinkContainer>, 'Account',
                        <Settings/>),
                    getItem(<GtfsImportModal operator={operator} messageApi={messageApi}/>, 'Import', <Import/>),
                    getItem(<ExportModal schedules={schedules} operator={operator} user={user} email={email} givenName={givenName} familyName={familyName}
                                         setFaultState={setFaultState} notificationApi={notificationApi}
                                         messageApi={messageApi} isAdmin={isAdmin}/>, 'Export', <Export/>),
                ].filter(Boolean)),
                getItem(<Nav.Link onClick={handleRefresh}>Refresh</Nav.Link>, 'Refresh', <ResetIcon/>, 'MenuBottom'),
                getItem(<a href="https://help.busable.app/" target="_blank" rel="noreferrer noopener">
                        <span className="menu-version">Help Centre<span>Learn Busable</span></span></a>, 'Help',
                    <Help/>, 'MenuBottom'),
                getItem(<a href={release_notes} target="_blank" rel="noreferrer noopener">
                        <span className="menu-version">What's New<span><VersionInfo npmVersion={version} /></span></span></a>, 'What\'s New',
                    <Info/>, 'MenuBottom'),
                getItem(<Nav.Link onClick={handleLogout}>{givenName || 'Logout'} <Logout/></Nav.Link>, 'Logging out...',
                    <div className="user-image"><User/></div>, 'MenuBottom'),
            ]);
        } else {
            // Show all menu items for non-Optibus operators or admin users, filtered by blocked views
            setItems([
                getItem('Planable', 'Planable', <img src={imgPlanable} alt=""/>, '', [
                    !isMenuItemBlocked('/services') && getItem(<LinkContainer to="/services"><Nav.Link>Services</Nav.Link></LinkContainer>, 'Services',
                        <BusSM/>),
                    !isMenuItemBlocked('/points') && getItem(<LinkContainer to="/points"><Nav.Link>Points</Nav.Link></LinkContainer>, 'Points', <Pin/>),
                    !isMenuItemBlocked('/calendars') && (isAdmin) && getItem(<LinkContainer to="/calendars"><Nav.Link>Calendars</Nav.Link></LinkContainer>, 'Calendars',
                        <Calendar/>),
                    !isMenuItemBlocked('/calendars-v2') && getItem(<LinkContainer to="/calendars-v2" className="badge-beta"><Nav.Link>Calendars v2</Nav.Link></LinkContainer>, 'Calendars v2',
                        <Calendar/>),
                    !isMenuItemBlocked('/transfers') && getItem(<LinkContainer to="/transfers"><Nav.Link>Transfers</Nav.Link></LinkContainer>, 'Transfers',
                        <Transfers/>),
                ].filter(Boolean)),
                getItem('Charterable', 'Charterable', <img src={imgCharterable} alt=""/>, '', [
                    !isMenuItemBlocked('/bookings/executive-dashboard') && getItem(<LinkContainer to="/bookings/executive-dashboard"><Nav.Link>Dashboard</Nav.Link></LinkContainer>, 'Dashboard', <BarChartOutlined />),
                    !isMenuItemBlocked('/enquiries') && getItem(<LinkContainer to="/enquiries" className="badge-beta"><Nav.Link>Enquiries</Nav.Link></LinkContainer>, 'Enquiries',<BusSM/>),
                    !isMenuItemBlocked('/bookings') && getItem(<LinkContainer to="/bookings" className="badge-beta"><Nav.Link>Bookings</Nav.Link></LinkContainer>, 'Bookings',<BusSM/>),
                    !isMenuItemBlocked('/customers') && getItem(<LinkContainer to="/customers"
                                           className="badge-beta"><Nav.Link>Customers</Nav.Link></LinkContainer>, 'Customers',
                        <HR/>),
                ].filter(Boolean)),
                getItem('Rosterable', 'Rosterable', <img src={imgRosterable} alt=""/>, '', [
                    !isMenuItemBlocked('/rostering') && getItem(<LinkContainer
                            to="/rostering"
                            className="badge-beta"><Nav.Link>Allocations</Nav.Link></LinkContainer>, 'Rosters',
                        <Calendar/>),
                    !isMenuItemBlocked('/blocks') && getItem(<LinkContainer
                            to="/blocks"
                            className="badge-beta"><Nav.Link>Blocks</Nav.Link></LinkContainer>, 'Blocks',
                        <Calendar/>),
                    !isMenuItemBlocked('/shiftbats') && getItem(<LinkContainer to="/shiftbats"><Nav.Link>Driver
                            Duties</Nav.Link></LinkContainer>, 'Driver Duties',
                        <Rostering/>),
                    isAdmin && !isMenuItemBlocked('/deadruns') && getItem(<LinkContainer to="/deadruns"><Nav.Link>Deadruns
                        </Nav.Link></LinkContainer>, 'Deadruns',
                        <Trackable/>),
                ].filter(Boolean)),
                getItem('Trackable', 'Trackable', <img src={imgTrackable} alt=""/>, '', [
                    !isMenuItemBlocked('/fleet_monitoring') && getItem(<LinkContainer to="/fleet_monitoring" className="badge-beta"><Nav.Link>Fleet Tracking
                        </Nav.Link></LinkContainer>, 'Fleet Monitoring',
                        <Trackable/>),
                    !isMenuItemBlocked('/fleet_monitoring_v2') && getItem(<LinkContainer to="/fleet_monitoring_v2" className="badge-beta"><Nav.Link>Fleet Tracking V2
                        </Nav.Link></LinkContainer>, 'Fleet Monitoring V2',
                        <Trackable/>),
                ].filter(Boolean)),
                getItem('Publishable', 'Publishable', <img src={imgPublishable} alt=""/>, '', [
                    !isMenuItemBlocked('/trip_planner') && getItem(<LinkContainer to={`/trip_planner`}><Nav.Link>Journey
                        Planner</Nav.Link></LinkContainer>, 'Journey Planner', <Services/>),
                    !isMenuItemBlocked('/timetables') && getItem(<LinkContainer to={`/timetables`}><Nav.Link>Service
                        Timetables</Nav.Link></LinkContainer>, 'Service Timetables', <BusSM/>),
                    !isMenuItemBlocked('/school_list') && getItem(<LinkContainer to={`/school_list`}><Nav.Link>School
                        Timetables</Nav.Link></LinkContainer>, 'School Timetables', <Timetable/>),
                    !isMenuItemBlocked('/venue_list') && getItem(<LinkContainer to={`/venue_list`}><Nav.Link>Venue
                        Timetables</Nav.Link></LinkContainer>, 'Venue Timetables', <Timetable/>),
                ].filter(Boolean)),
                (operator.features.beta || operator.features.all || operator.features.manageable) && getItem('Manageable', 'Manageable',
                    <img
                        src={imgRosterable} alt=""/>, '', [
                        !isMenuItemBlocked('/hrm') && getItem(<LinkContainer to="/hrm"><Nav.Link>Staff</Nav.Link></LinkContainer>, 'Staff', <HR/>),
                        !isMenuItemBlocked('/policies') && getItem(<LinkContainer to="/policies"><Nav.Link>Policy</Nav.Link></LinkContainer>, 'Policy', <HR/>),
                        !isMenuItemBlocked('/vehicleTypes') && getItem(<LinkContainer to="/vehicleTypes" className="badge-beta"><Nav.Link>Vehicle
                            Types</Nav.Link></LinkContainer>, 'Vehicle Types', <BusSM/>),
                        !isMenuItemBlocked('/fleet') && getItem(<LinkContainer to="/fleet"
                                               className="badge-beta"><Nav.Link>Fleet</Nav.Link></LinkContainer>, 'Fleet',
                            <BusSM/>),
                        !isMenuItemBlocked('/hrm') && getItem(<LinkContainer to="/hrm"
                                               className="badge-beta"><Nav.Link>Depot</Nav.Link></LinkContainer>, 'Depot',
                            <Pin/>),
                        !isMenuItemBlocked('/students') && getItem(<LinkContainer to="/students"><Nav.Link>Students</Nav.Link></LinkContainer>, 'Students',
                            <HR/>),
                    ].filter(Boolean)),
                (operator.features.beta || operator.features.all || operator.features.reportable) && getItem('Reportable', 'Reportable', <img
              src={imgReportable} alt=""/>, '', [
                !isMenuItemBlocked('/reportable/admin') && (isAdmin) && getItem(<LinkContainer to="/reportable/admin"><Nav.Link>Admin</Nav.Link></LinkContainer>, 'Admin', <HR/>),
                    !isMenuItemBlocked('/reportable/otr-dashboard') && getItem(<LinkContainer to="/reportable/otr-dashboard"><Nav.Link>On Time Running</Nav.Link></LinkContainer>, 'OTRDashboard', <BarChartOutlined />),
                    !isMenuItemBlocked('/reportable/osr') && getItem(<LinkContainer to="/reportable/osr"><Nav.Link>Operational Reports</Nav.Link></LinkContainer>, 'OSR', <OTR/>),
                    !isMenuItemBlocked('/reportable/visualizer') && getItem(<LinkContainer to="/reportable/visualizer"><Nav.Link>Visualizer</Nav.Link></LinkContainer>, 'Visualizer', <OTR/>),
                    !isMenuItemBlocked('/reportable/diff') && getItem(<LinkContainer to="/reportable/diff"><Nav.Link>Diff-Checker</Nav.Link></LinkContainer>, 'Diff-Checker', <OTR/>),
                ].filter(Boolean)),
                (operator.features.beta || operator.features.all ||operator.features.apps) && getItem('Apps', 'Apps',
                    <Marketplace/>, '', [
                        !isMenuItemBlocked('/marketplace') && getItem(<LinkContainer
                                to="/marketplace"><Nav.Link>Explore</Nav.Link></LinkContainer>, 'Explore',
                            <Explore/>),
                        !isMenuItemBlocked('/sms') && getItem(<LinkContainer to="/sms"><Nav.Link>SMS</Nav.Link></LinkContainer>, 'SMS', <SMS/>),
                        getItem(<a
                            href={`${config.cms.URL}/sso/cognito/callback?token=${jwtToken}&firstName=${operator.operatorName}&companyId=${operator.companyId}`}
                            target="_blank" rel="noreferrer">
                            <span className="menu-version">Website CMS</span>
                        </a>, 'CMS', <Globe/>),
                    ].filter(Boolean)),
                !isMenuItemBlocked('/settings') && getItem('Settings', 'Settings', <Settings/>, 'MenuBottom', [
                    getItem(<LinkContainer to="/settings"><Nav.Link>Account</Nav.Link></LinkContainer>, 'Account',
                        <Settings/>),
                    getItem(<GtfsImportModal operator={operator} messageApi={messageApi}/>, 'Import', <Import/>),
                    getItem(<ExportModal schedules={schedules} operator={operator} user={user} email={email} givenName={givenName} familyName={familyName}
                                         setFaultState={setFaultState} notificationApi={notificationApi}
                                         messageApi={messageApi} isAdmin={isAdmin}/>, 'Export', <Export/>),
                    (isAdmin) && getItem(<AdminModal allowedOperators={allowedOperators} isAdmin={isAdmin}
                                                     apiKey={apiKey} messageApi={messageApi}/>, 'Admin', <Settings/>),
                ].filter(Boolean)),
                getItem(<Nav.Link onClick={handleRefresh}>Refresh</Nav.Link>, 'Refresh', <ResetIcon/>, 'MenuBottom'),
                getItem(<a href="https://help.busable.app/" target="_blank" rel="noreferrer noopener">
                        <span className="menu-version">Help Centre<span>Learn Busable</span></span></a>, 'Help',
                    <Help/>, 'MenuBottom'),
                getItem(<a href={release_notes} target="_blank" rel="noreferrer noopener">
                        <span className="menu-version">What's New<span><VersionInfo npmVersion={version} /></span></span></a>, 'What\'s New',
                    <Info/>, 'MenuBottom'),
                getItem(<Nav.Link onClick={handleLogout}>{givenName || 'Logout'} <Logout/></Nav.Link>, 'Logging out...',
                    <div className="user-image"><User/></div>, 'MenuBottom'),
            ].filter(Boolean)); // Remove any empty menu groups
        }
    }, [setItems, schedules, operator, setFaultState, handleLogout, isAdmin, messageApi, allowedOperators, apiKey, notificationApi,
        user, email, givenName, familyName, version, jwtToken, isMenuItemBlocked]); // Added user state variables to dependencies

    const rootSubmenuKeys = ['Planable', 'Charterable', 'Rosterable', 'Trackable', 'Publishable', 'Manageable', 'Reportable', 'Apps', 'Settings'];

    const [openKeys, setOpenKeys] = useState(['Planable']);
    const onOpenChange = (keys) => {
        const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
        if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            setOpenKeys(keys);
        } else {
            setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
    };

    const onMenuSelect = useCallback((item) => {
        console.log('MENU SLELECT: ', item);
        setBreadcrumbs(breadcrumbs => ['Export', 'What\'s New', 'Help', 'Logging out...'].includes(item.key) ? breadcrumbs : [...item.keyPath].reverse());
        setBreadcrumb(null);
        setPageTitle(pageTitle => ['Export', 'What\'s New', 'Help', 'Logging out...'].includes(item.key) ? pageTitle : item.key);
    }, [setBreadcrumbs, setBreadcrumb, setPageTitle]);

    useEffect(() => {
        setBreadcrumbs([getSubMenu(location.pathname, operator, isAdmin),
            <Link to={`/${location.pathname.split('/')[1]}`}>{getMenu(location.pathname)}</Link>]);
        setBreadcrumb(null);
        setOpenKeys([getSubMenu(location.pathname, operator, isAdmin)]);
        setPageTitle(getMenu(location.pathname));
    }, [location, setBreadcrumb, setBreadcrumbs, setOpenKeys, setPageTitle, operator, isAdmin]);

    // MOBILE UX: Auto-hide main navigation sidebar on Trackable V2 load (mobile only)
    // Only auto-collapse on initial route load, not when user manually toggles menu
    useEffect(() => {
        const isTrackableV2Route = location.pathname === '/fleet_monitoring_v2' || location.pathname === '/fleet_monitoring';
        const isMobile = window.innerWidth <= 768;
        
        // Only auto-collapse if:
        // 1. We're on a Trackable V2 route
        // 2. We're on mobile
        // 3. App is ready
        // 4. We haven't already auto-collapsed for this route (prevents re-collapsing when user opens menu)
        if (isTrackableV2Route && isMobile && isAppReady && autoCollapsedRouteRef.current !== location.pathname) {
            // Small delay to allow page to render, then animate sidebar collapse
            const timer = setTimeout(() => {
                setCollapsed(true);
                autoCollapsedRouteRef.current = location.pathname; // Mark this route as auto-collapsed
            }, 500); // 500ms delay for smooth animation after page load
            
            return () => clearTimeout(timer);
        }
        
        // Reset the ref when navigating away from Trackable V2 routes
        if (!isTrackableV2Route) {
            autoCollapsedRouteRef.current = null;
        }
    }, [location.pathname, isAppReady]);

    useEffect(() => {
        if (isAuthenticating) {
            return;
        }
        if (isAuthenticated) {
            const interval = setInterval(() => {
                if (!faultModalVisible) {
                    checkAuth(setFaultState, apiKey);
                }
            }, 30 * 1000);
            return () => {
                clearInterval(interval);
            };
        }
    }, [setFaultState, faultState, apiKey, isAuthenticating, isAuthenticated, faultModalVisible]);

    // useEffect(() => {
    //     console.log('Loading Busable v' + version);
    //     const currentVersion = store.local.get('busable-version');
    //     if (!isPublic && !location.pathname.includes('/login') && !location.pathname.includes('/logout') && !location.pathname.includes('/reset') && currentVersion !== version && isAuthenticated) {
    //         setNewVersion(true);
    //         // Don't set the version in local storage until user makes a choice
    //     }
    // }, [isPublic, version, setNewVersion, location?.pathname, isAuthenticated]);

    const newVersion = useMemo(() => {
        if (isPublic || isAuthenticating || location.pathname.includes('/login') || location.pathname.includes('/logout') || location.pathname.includes('/reset')) {
            return false;
        }
        const currentVersion = store.local.get('busable-version');
        return currentVersion !== version && !versionChoiceMade;
    }, [version, versionChoiceMade, location?.pathname, isAuthenticating]);


    useEffect(() => {
        if(user && editor && messageApi && setFaultState && !isAuthenticating && (versionChoiceMade || !newVersion)) {
            routesModelExpiryService.init({user, editor, messageApi, setFaultState}).then(() => {
                console.log('RoutesModelExpiryService initialised.');
            })
        } else {
            console.log(`RoutesModelExpiryService not initialised. user: ${user}, editor: ${editor}, messageApi: ${messageApi}, setFaultState: ${setFaultState}, isAuthenticating: ${isAuthenticating}, newVersion: ${newVersion}, versionChoiceMade: ${versionChoiceMade}`);
        }
    }, [user, editor, messageApi, setFaultState, isAuthenticating, newVersion, versionChoiceMade]);

    useEffect(() => {
        if(operator) {
            store.session.set('busable-org-id', operator.orgId || operator.companyId);
            store.session.set('busable-region-id', operator.regionId || operator.operatorId);
            routesModelExpiryService.setOperator(operator);
        }
    }, [operator]);

    useEffect(() => {

        // Check for WebSocket simulation query parameters
        const urlParams = new URLSearchParams(window.location.search);
        const simulateWebSocket = urlParams.get('simulate_websocket');
        const failureType = urlParams.get('failure_type') || 'timeout';
        const timeoutMs = parseInt(urlParams.get('timeout_ms')) || 5000;
        
        if (simulateWebSocket === 'true') {
            console.log('🧪 WebSocket simulation enabled via URL parameters');
            console.log('🧪 Failure type:', failureType);
            console.log('🧪 Timeout (ms):', timeoutMs);
            
            // Enable WebSocket simulation with URL parameters
            routesModelExpiryService.enableWebSocketSimulation({
                failureType: failureType,
                timeoutMs: timeoutMs
            });
        }

        async function onLoad() {

            try {

                let user = {attributes: {email: 'local@local.com', given_name: 'Local', family_name: 'Local Dog'}};
                let isAdmin = config.local, authenticated = config.local;
                if (!config.local) {
                    await Auth.currentSession();
                    user = await Auth.currentUserInfo();
                    if (!user?.attributes) {
                        setIsAuthenticating(false);
                        return;
                    }
                    authenticated = true;
                    isAdmin = user.attributes['custom:isAdmin'] === 'true';
                }

                let _key = await getKey();
                if (!config.local && user?.attributes['custom:operatorId'] !== _key &&
                    (!user?.attributes['custom:allowedOperators'] || (user?.attributes['custom:allowedOperators'] !== 'all' &&
                        !user?.attributes['custom:allowedOperators'].split(',').includes(_key)))) {
                    store.session.remove('busable-operator-id');
                    _key = user?.attributes['custom:operatorId'];
                }

                routesModelExpiryService.setApiKey(_key);
                const {editor} = getEditor({user});

                const _setOperator = operator => {
                    setOperator(operator);
                    setFeatures(operator.features);
                    if (isAdmin) {
                        operator.features.all = true;
                    }

                    if (operator?.opts?.snappy?.optOut) {
                        console.log('Opting out of snappy mode.');
                        routesModelExpiryService.optOutSuperFast();
                    }
                    console.log('Super snappy: ', !operator?.opts?.snappy?.optOut);

                    config.operator = operator;
                    console.log(`OPERATOR: `, operator);
                    console.log(`FEATURES: `, util.inspect(operator.features));
                    if (!config.local && user?.attributes['custom:operatorId'] !== _key) {
                        setUserOperator(operator).then(() => console.log('User operator set to ', _key));
                    }

                };
                let operator;
                if (!authenticated) {
                    console.log('Unauthenticated.. get public op.');
                    operator = await operatorModelData.get(_key);
                    operator.regionId = operator.regionId || _key;
                } else {
                    operator = await getOperator(_key);
                    _setOperator(operator);
                    console.log('Authenticated.. get ops.');
                    operatorModelData.addListener({
                        id: 'appOperatorListener', loaded: operators => {
                            console.log('Allowed operators: ', operators);
                            setAllowedOperators(values(operators).sort((a, b) => (a.operatorName || '').localeCompare(b.operatorName || '')));
                        }
                    });
                }
                console.log(`Found key: ${_key}`);
                setApiKey(_key);

                store.session.set('busable-operator-id', _key);

                // console.log(`OPERATOR: `, operator);
                // console.log(`FEATURES: `, util.inspect(operator.features));

                // setOperator(operator)
                // setFeatures(operator.features);
                // operator.features.all = isAdmin


                // dutyModelExpiryService.init(_key).then(() => console.log(`dutyModelExpiryService started.`))
                // routeModelData.getAll(key).then(() => console.log(`RouteModelData ready.`))
                // stopModelData.getAll(key).then(() => console.log(`StopModelData ready.`))
                // await Promise.all([await modelExpiryService.init(), await routeModelData.get(key), await stopModelData.get(key)])

                scheduleModelData.addListener({
                    id: 'appScheduleListener', setterFn: setPrivateSchedules, loaded: schedules => {
                        setPrivateSchedules(schedules);
                    }
                });
                publicScheduleModelData.addListener({
                    id: 'appPublicScheduleListener', setterFn: setPublicSchedules, loaded: publicSchedules => {
                        setPublicSchedules(publicSchedules);
                    }
                });
                // let schedules = await scheduleModelData.getAll(_key)
                // if (schedules) {
                //     console.log('schedule count:', Object.keys(schedules).length);
                //     setSchedules(schedules)
                // }

                // let user = {attributes: {email: 'graham@cortexus.com.au'}}
                if (!config.local) {
                    setUser(user);
                    setEmail(user.attributes['email']);
                    setGivenName(user.attributes['given_name']);
                    setFamilyName(user.attributes['family_name']);
                    driverShiftModelData.addListener({id: 'appDriverShiftListener', loaded: setDriverShifts});
                    vehicleModelData.addListener({id: 'appVehicleModelData', loaded: setVehicles});
                    // setDriverShifts(keyBy(await driverShiftModelData.getAll(_key), 'shiftId'))
                    // setDrivers(keyBy(await driverModelData.getAll(_key), 'driverId'))
                    // setVehicles(keyBy(await vehicleModelData.getAll(_key), 'vehicleId'))
                    if (!isAdmin) {
                        await startAnalytics();
                    }
                }
                setIsAdmin(isAdmin);
                userHasAuthenticated(authenticated);

            } catch (e) {
                if (!isPublic) {
                    console.log(`error loading app... ${e}`);
                    if (e.message?.includes('No Operator')) {
                        const sessionOpId = store.session.get('busable-operator-id');
                        if (sessionOpId?.length) {
                            store.session.remove('busable-operator-id');
                            return window.location.reload();
                        }
                        Auth.signOut().then(() => console.log('Signed out due to ', e));
                        messageApi.error('There is something wrong with your user account. Please contact us for help.', 60);
                    }

                    await Auth.signOut();
                    history.push("/login");
                } else {
                    let _key = await getKey();
                    // if (_key && location.pathname.includes('/timetables')) {
                    //     await routesModelExpiryService.init({
                    //         apiKey: _key,
                    //         messageApi,
                    //         setFaultState,
                    //         modelFilter: ['RouteComment', 'StopComment', 'Stop', 'Transfer', 'Route', 'Schedule']
                    //     })
                    if (_key) {
                        const operator = await getPubOperator(_key);
                        operator.regionId = operator.regionId || _key;
                        setOperator(operator);
                        config.operator = operator;
                    }
                }
                // history.push("/login");
                // throw e
                // if (isAdmin) {
                //     onError(e);
                // }
                // handleLogout();
            }

        }

        // Set up model service loading listener before initializing
        routesModelExpiryService.addLoadedListener({
            id: 'appModelServiceListener',
            loaded: () => {
                console.log('✅ All models loaded and cached - app is ready');
                setIsModelServiceReady(true);
            }
        });

        onLoad().then(() => {
            console.log('App loaded...');
            setIsAuthenticating(false);
        }).catch(e => {
            console.error('Error loading app: ', e);
            history.push('/login');
        });

        return () => {
            routesModelExpiryService.deinit();
            routesModelExpiryService.removeLoadedListener('appModelServiceListener');
            scheduleModelData.removeListener('appScheduleListener');
            publicScheduleModelData.removeListener('appPublicScheduleListener');
        };
    }, [setPrivateSchedules, setPublicSchedules, setFeatures, setApiKey, setIsAuthenticating, setVehicles, setUser, setEmail, setGivenName,
        setFamilyName, setDriverShifts, history, handleLogout, messageApi, version]);

    useEffect(() => {
        if(privateSchedules && publicSchedules) {
            setSchedules({...privateSchedules, ...publicSchedules});
        }
    }, [privateSchedules, publicSchedules]);

    async function handleSwitchRegion(operator) {
        console.log('Setting operator: ', operator.operatorId);
        try {
            window.location.replace(`/switch/${operator.companyId}/${operator.operatorId}`);
        } catch (e) {
            console.log(e);
        }
    }

    async function startAnalytics() {
        console.log('Starting analytics...');
        /* -- Initialise Hotjar behaviour analytics -- */
        const siteId = 3470107;
        const hotjarVersion = 6;

        Hotjar.init(siteId, hotjarVersion);

        // Initializing with `debug` option:
        // Hotjar.init(siteId, hotjarVersion, {
        //     debug: true
        // });

        let user = await Auth.currentUserInfo();
        let userId = user.attributes['email'];

        Hotjar.identify(userId, {
            email: userId,
        });

        /* -- Initialise Google Analytics GA4 -- */
        ReactGA.initialize('G-B0S037Y0L9');
    }

    const hideMenu = useCallback(() => {
        return isPublic && !isAuthenticated;
    }, [isAuthenticated]);

    const showHeader = useCallback(() => {
        return location.pathname.includes('trial');
    }, [location?.pathname]);

    useEffect(function ensureCharterOnlyForOptibus() {
        if (!isAdmin && !isPublic && operator?.opts?.external?.optibus?.apiKey?.length &&
            !window.location.pathname.includes('bookings/executive-dashboard') &&
            !window.location.pathname.includes('charters') &&
            !window.location.pathname.includes('bookings') &&
            !window.location.pathname.includes('customers') &&
            !window.location.pathname.includes('settings') &&
            !window.location.pathname.includes('deadruns') &&
            !window.location.pathname.includes('points')) {
            window.location.replace('/bookings');
        }
    }, [isAdmin, operator]);

    return (
        <div>
        {contextHolder}
        {notificationContextHolder}
        {newVersion ? (
            <VersionCheckPage 
                version={version}
                releaseNotesUrl={release_notes}
                onProceed={handleVersionProceed}
                onClearCache={handleVersionClearCache}
                messageApi={messageApi}
            />
        ) : !isAppReady && isAuthenticated ? (
            <SplashPage messageApi={messageApi} modelService={routesModelExpiryService} isAuthenticating={isAuthenticating} />
        ) : (
            <>
            <FaultModal {...faultState} visible={faultModalVisible} setVisible={setFaultModalVisible}/>
            <Layout hasSider={!hideMenu()} className="app-main">
                {!hideMenu() && ((features && operator) || isAdmin) ? (
                    <>
                        <Sider collapsible collapsed={collapsed} onCollapse={(value) => {
                            if (value === false && collapsed === true) {
                                // Expanding from collapsed state - add delay
                                setIsExpanding(true);
                                setTimeout(() => {
                                    setCollapsed(false);
                                    setIsExpanding(false);
                                }, 300); // 300ms delay
                            } else {
                                // Collapsing or other state changes - immediate
                                setCollapsed(value);
                            }
                        }}
                               className="app-sider"
                               collapsedWidth="66" width="235">
                            <div className={`sider-logo ${isExpanding ? 'expanding' : ''}`} onClick={() => {
                                if (!collapsed) {
                                    // Collapsing - immediate
                                    setCollapsed(true);
                                } else {
                                    // Expanding from collapsed - add delay
                                    setIsExpanding(true);
                                    setTimeout(() => {
                                        setCollapsed(false);
                                        setIsExpanding(false);
                                    }, 300); // 300ms delay
                                }
                            }}><Navbar.Brand>
                                <Image
                                    src={logoImage}
                                    height="28"
                                    className="d-inline-block align-center"
                                /><Image
                                src={logoImage2}
                                height="18"
                                className="d-inline-block align-center"
                            />{' '}
                            </Navbar.Brand></div>
                            <Menu theme="dark" defaultSelectedKeys={[pageTitle]} mode="inline" items={items}
                                  openKeys={openKeys} onOpenChange={onOpenChange} onSelect={onMenuSelect}/>
                            <Dropdown className="region-dropdown">
                                <Dropdown.Toggle
                                    as={CustomToggle}><Switch/><span>{operator?.operatorName || 'No region'}</span><i
                                    className="menu-icon-right"></i></Dropdown.Toggle>
                                <Dropdown.Menu as={CustomMenu} isAdmin={isAdmin} hideBackupRegions={hideBackupRegions} setHideBackupRegions={setHideBackupRegions}>
                                    {allowedOperators?.length > 1 && allowedOperators
                                        .filter(operator => operator.operatorId !== apiKey)
                                        .filter(operator => hideBackupRegions ? (!operator.operatorId.includes('_backup_') && !operator.operatorId.match(/\d{8}$/)) : true)
                                        .map(operator => (
                                        <Dropdown.Item key={`OpRegionDropdown-${operator.operatorId}`}
                                                       onClick={() => handleSwitchRegion(operator)}
                                                       variant="light">{operator.operatorName}</Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </Sider>
                    </>
                ) : <></>}
                <Layout className="app-layout">
                    <Header className="d-flex app-header">
                        {!hideMenu() && features && operator ? (
                                <>
                                    <div className="mr-4">
                                        <h1 className="page-title">{pageTitle}</h1>
                                        <Breadcrumb className="app-breadcrumb">
                                            {process.env.REACT_APP_STAGE && process.env.REACT_APP_STAGE !== 'prod' &&
                                                <Breadcrumb.Item
                                                    key={'Op_Stage_bc'}>
                                                    <span style={{color: 'red'}}>
                                                    <strong>{process.env.REACT_APP_STAGE}</strong></span>
                                                </Breadcrumb.Item>
                                            }
                                            <Breadcrumb.Item
                                                key={'Op_Name_bc'}>{operator.operatorName}</Breadcrumb.Item>
                                            {breadcrumbs.map(title => (
                                                <Breadcrumb.Item key={`${title}_bc`}>{title}</Breadcrumb.Item>))}
                                            {breadcrumb && <Breadcrumb.Item
                                                key={`${breadcrumb}_bc`}>{breadcrumb}</Breadcrumb.Item>}
                                        </Breadcrumb>
                                    </div>
                                    <Button
                                        className={`menu-sm-open ${collapsed ? 'menu-collapsed' : 'menu-expanded'}`}
                                        type="primary"
                                        onClick={() => {
                                            if (!collapsed) {
                                                // Collapsing - immediate
                                                setCollapsed(true);
                                            } else {
                                                // Expanding from collapsed - add delay
                                                setIsExpanding(true);
                                                setTimeout(() => {
                                                    setCollapsed(false);
                                                    setIsExpanding(false);
                                                }, 300); // 300ms delay
                                            }
                                        }}
                                    ><MenuOutlined/></Button>
                                </>
                            )
                            : showHeader() ?
                                null //{/* Removed public header for login page to avoid solid banner */}
                                : <></>
                        }
                    </Header>

                    <Content className="app-content">
                        <div className={`App ${hideMenu() ? 'publicContainer' : 'container'}`}>
                            <ErrorBoundary>
                                
                                    <AppContext.Provider
                                        value={{
                                            user,
                                            email,
                                            givenName,
                                            familyName,
                                            isAuthenticating,
                                            isAuthenticated,
                                            userHasAuthenticated,
                                            schedules,
                                            setSchedules,
                                            privateSchedules,
                                            setPrivateSchedules,
                                            publicSchedules,
                                            setPublicSchedules,
                                            apiKey,
                                            operator,
                                            setOperator,
                                            setApiKey,
                                            fullUrl,
                                            features,
                                            setFeatures,
                                            allowedOperators,
                                            setAllowedOperators,
                                            isAdmin,
                                            driverShifts,
                                            vehicles,
                                            setPageTitle,
                                            breadcrumbs,
                                            setBreadcrumb,
                                            setFaultState,
                                            handleLogout,
                                            messageApi,
                                            notificationApi,
                                            isPublic,
                                            allRouteComments,
                                            allStopComments,
                                            editor,
                                            setEditor,
                                            chatContext,
                                            setChatContext,
                                            setChatOpen
                                        }}>
                                      <ReportsProvider>
                                        <BookingProvider>
                                          {/*<ChatModal visible={chatOpen} setVisible={setChatOpen} />*/}
                                          <RoutesComponent isAuthenticating={isAuthenticating} setChatContext={setChatContext} setChatOpen={setChatOpen} operator={operator}/>
                                          {user && <ReportIssueButton user={user} operator={operator} setOperator={setOperator} breadcrumbs={breadcrumbs} isAdmin={isAdmin} messageApi={messageApi} />}
                                        </BookingProvider>
                                    </ReportsProvider>
                                </AppContext.Provider>
                            </ErrorBoundary>
                            {!hideMenu() &&
                                <CookieConsent
                                    location="bottom"
                                    buttonText="Accept"
                                    cookieName="acceptCookiesCookie"
                                    containerClasses="cookie-consent-banner"
                                    style={{
                                        backgroundColor: '#6B54F9',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        maxWidth: '720px',
                                        width: '80%',
                                        padding: '0 10px',
                                        borderRadius: '10px'
                                    }}
                                    buttonStyle={{
                                        color: '#333',
                                        fontSize: '13px',
                                        backgroundColor: 'white',
                                        borderRadius: '10px',
                                        border: '1px solid #333'
                                    }}
                                    expires={150}>This website uses cookies to improve the site and enhance the user
                                    experience.</CookieConsent>}
                        </div>
                    </Content>
                </Layout>
            </Layout>
            <MessageCard />
            </>)}
        </div>
        // ) : <div>
        //     {/*<div className="lander">*/}
        //     {/*    <h1>Bus Transport Software</h1>*/}
        //     {/*    <h5>Flexible end-to-end bus transport software.</h5>*/}
        //     {/*    <h5>Plan, schedule, publish and enable your bus services easily anywhere, anytime.</h5>*/}
        //     {/*    <div className="pt-3">*/}
        //     {/*        /!* <Link to="/login" className="btn btn-primary btn-lg mr-3">*/}
        //     {/*            Login*/}
        //     {/*        </Link> *!/*/}
        //     {/*        /!*<Link to="/signup" className="btn btn-success btn-lg">*!/*/}
        //     {/*        /!*  Signup*!/*/}
        //     {/*        /!*</Link>*!/*/}
        //     {/*    </div>*/}
        // <LoadMessage size={"lg"}/>
        // {/*</div>*/}
        // </div>
    );
}
